/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { ConfirmationCssClasses, HomeworkStatusTitles } from "../../../../../../../_helpers/Helpers";

export const StatusColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${
      ConfirmationCssClasses[row.isEvaluated]
    } label-inline`}
  >
    {HomeworkStatusTitles[row.isEvaluated]}
  </span>
);